var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-ticket"},[_c('div',{staticClass:"user-ticket__title"},[_vm._v(_vm._s(_vm.$tr('profile.userTicket.text')))]),_c('div',{staticClass:"user-ticket__number"},[_vm._v(_vm._s(_vm.userTicket))])])
}
var staticRenderFns = []

export { render, staticRenderFns }